export default __webpack_public_path__ + "static/media/zoom.d2227a18.jpg";